<div class="c-field-value -money" [ngClass]="customClass">
  <ng-container [ngSwitch]="true">
    <ng-container *ngSwitchCase="+data === 0">
      <span class="c-field-value__text -gray" [class.-white]="customClass === '-dark'">
        <gtd-ui-field-crm-currency [data]="data" [currencyCode]="currencyCode"></gtd-ui-field-crm-currency>
      </span>
    </ng-container>
    <ng-container *ngSwitchCase="+data < 0">
      <span class="c-field-value__text -red">
        (<gtd-ui-field-crm-currency [data]="transformPositive(data)" [currencyCode]="currencyCode"></gtd-ui-field-crm-currency>)
      </span>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <span class="c-field-value__text -green">
        <gtd-ui-field-crm-currency [data]="data" [currencyCode]="currencyCode"></gtd-ui-field-crm-currency>
      </span>
    </ng-container>
  </ng-container>
</div>
